















































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Role from '@/models/role';
import User from '@/models/user';

@Component
export default class NotificationModal extends Vue {
  @Prop() notification: any;
  @Prop() visible: boolean;
  @Prop() clearNotification: any;
  title = '';
  desc = '';
  image = '';

  @Watch('notification', {immediate: true})
  updateData(noti: any, oldValue: any) {
    if (!noti) return;
    this.title = noti.newsHeading;
    this.desc = noti.newsDescription;
    this.image = noti.newsImage ? 'data:image/png;base64,' + noti.newsImage : null;
  }

  @Watch('visible', {immediate: true})
  modalVisible(newValue: boolean, oldValue: boolean) {
    if (!newValue) return;

    if (this.clearNotification && this.notification) {
      this.clearNotification(this.notification.newsId);
    }
  }
}
